import React, {Component} from "react"
import { Navigate } from "react-router-dom";
import { dontMakeCallOnOpen, setLegitCall, setAvailableNearby } from "../../Redux/TrackerActions";
import {store} from "../../App";
import { connect } from 'react-redux';
import { setToast, setDialog, clearDialog, setLoader, clearLoader } from "../../Redux/OverlayActions";
import WavingHand from "./WavingHand";
import { withTranslation } from "../../hooks/withTranslation";
import { getDistanceFromLatLonInKm } from "../../utils/geo";
import { getActiveCall, clearActiveCall } from "../../utils/callStatus";

class CombinedButton extends Component {
    constructor() {
        super();
        this.state = { 
            redirectToCall: false,
            redirectToAddress: false,

            showLocationFailedDialog: false,
            showLocationDeniedDialog: false,

            oproepGeplaatst: false,
        };

        this.handleClick = this.handleClick.bind(this);

        this.checkPermissionLocation = this.checkPermissionLocation.bind(this);

        this.preRequestPermissionLocation = this.preRequestPermissionLocation.bind(this);
        this.handlePreRequestPermissionLocationResponse = this.handlePreRequestPermissionLocationResponse.bind(this);

        this.requestLocation = this.requestLocation.bind(this);
        this.handleLocationRecieved = this.handleLocationRecieved.bind(this);
        this.handleLocationError = this.handleLocationError.bind(this);
        this.handleLocationDenied = this.handleLocationDenied.bind(this);
        this.handleLocationFailed = this.handleLocationFailed.bind(this);

        this.checkGeopositionAgainstStoredPosition = this.checkGeopositionAgainstStoredPosition.bind(this);

        this.makeLocationTranslation = this.makeLocationTranslation.bind(this);
        this.handleLocationTranslationFailed = this.handleLocationTranslationFailed.bind(this);
        this.setAdresStorage = this.setAdresStorage.bind(this);
        this.isStoredAddressValid = this.isStoredAddressValid.bind(this);

        this.checkKarrenInDeBuurt = this.checkKarrenInDeBuurt.bind(this);
        this.handleAvailableNearby = this.handleAvailableNearby.bind(this);
        this.handleNoAvailableNearby = this.handleNoAvailableNearby.bind(this);
        this.handleBlockTooFarAway = this.handleBlockTooFarAway.bind(this);
    }

    componentDidMount() {
        this.checkCallExpiry();

        // Check every 30 seconds if the call period has expired
        this.callExpiryInterval = setInterval(() => {
            this.checkCallExpiry();
        }, 30000);

        if (this.props.makeCallOnOpen) {
            this.handleClick(true);
        }
        store.dispatch(dontMakeCallOnOpen());
    }

    componentWillUnmount() {
        if (this.callExpiryInterval) {
            clearInterval(this.callExpiryInterval);
        }
    }

    checkCallExpiry() {
        // Active while now < the chosen "langskomen" deadline (see callStatus).
        const active = getActiveCall() !== null;
        if (active !== this.state.oproepGeplaatst) {
            this.setState({ oproepGeplaatst: active });
        }
    }

    handleClick(skipLocationPopup = false) {
        this.props.handleMapClick();

        const active = getActiveCall();
        if (active) {
            this.showCallStatusDialog(active);
        } else {
            this.checkPermissionLocation(skipLocationPopup);
        }
    }

    showCallStatusDialog(call) {
        const { t } = this.props;
        const addressLine = [
            [call.straat, call.nr].filter(Boolean).join(' '),
            [call.postcode, call.gemeente].filter(Boolean).join(' '),
        ].filter(Boolean).join(', ');

        const lines = [];
        if (addressLine) {
            lines.push(`<strong>${t('dialogs.callPlaced.addressLabel', 'Adres')}:</strong> ${addressLine}`);
        }
        if (call.aantal) {
            lines.push(`<strong>${t('dialogs.callPlaced.peopleLabel', 'Aantal personen')}:</strong> ${call.aantal}`);
        }
        if (call.langskomenLabel) {
            lines.push(`<strong>${t('dialogs.callPlaced.untilLabel', 'Langskomen tot')}:</strong> ${call.langskomenLabel}`);
        }

        store.dispatch(setDialog({
            title: t('dialogs.callPlaced.title', 'Je oproep loopt'),
            message: lines.join('<br>'),
            btn1Text: t('common.ok', 'Ok'),
            btn1Theme: "primary",
            btn1Title: "ok",
            btn2Text: t('dialogs.callPlaced.cancelButton', 'Annuleer oproep'),
            btn2Theme: "danger",
            btn2Title: "cancel",
            response: (which) => {
                store.dispatch(clearDialog());
                if (which === "cancel") {
                    this.cancelCall();
                }
            },
        }));
    }

    cancelCall() {
        const { t } = this.props;
        store.dispatch(setLoader({
            title: t('loaders.pleaseWait', 'Even geduld...'),
            message: t('dialogs.callPlaced.cancelling', 'Je oproep wordt geannuleerd'),
        }));

        const formData = new FormData();
        formData.append('udid', window.localStorage.getItem('udid') || '');
        formData.append('token', window.localStorage.getItem('token') || '');

        fetch(process.env.REACT_APP_API_HREF + "legacycopy.php?action=remove_oproep", {
            method: 'POST',
            body: formData,
        }).then(response => response.json()).then(data => {
            store.dispatch(clearLoader());
            if (data.status === 200) {
                // Only drop the local snapshot once the server confirms; the FAB
                // resets via checkCallExpiry / oproepGeplaatst.
                clearActiveCall();
                this.setState({ oproepGeplaatst: false });
                store.dispatch(setToast({
                    message: t('dialogs.callPlaced.cancelled', 'Je oproep is geannuleerd'),
                    theme: "success",
                }));
            } else {
                store.dispatch(setToast({
                    message: t('dialogs.callPlaced.cancelFailed', 'Het annuleren is niet gelukt. Probeer het later opnieuw.'),
                    theme: "error",
                }));
            }
        }).catch(() => {
            store.dispatch(clearLoader());
            store.dispatch(setToast({
                message: t('dialogs.callPlaced.cancelFailed', 'Het annuleren is niet gelukt. Probeer het later opnieuw.'),
                theme: "error",
            }));
        });
    }

    checkPermissionLocation(skipLocationPopup = false) {
        const that = this;
        navigator.permissions && navigator.permissions.query({name: 'geolocation'}).then(function(PermissionStatus) {
            if('granted' === PermissionStatus.state) {
                //Location permission granted
                that.requestLocation();
            } else if('denied' === PermissionStatus.state) {
                //Location permission denied
                that.checkGeopositionAgainstStoredPosition(null, null);
            } else {
                //Location permission unknown
                if (skipLocationPopup) {
                    that.checkGeopositionAgainstStoredPosition(null, null);
                } else {
                    that.preRequestPermissionLocation();   
                }
            }
        });
        if (!navigator.permissions) {
            //This browser does not have the permissions API
            //Fallback to localstorage polyfill
            const geolocationState = (localStorage.getItem('geolocation') ?? '');
            if('granted' === geolocationState) {
                //Location permission granted
                that.requestLocation();
            } else if('denied' === geolocationState) {
                //Location permission denied
                that.checkGeopositionAgainstStoredPosition(null, null);
            } else {
                //Location permission unknown
                if (skipLocationPopup) {
                    that.checkGeopositionAgainstStoredPosition(null, null);
                } else {
                    that.preRequestPermissionLocation();   
                }
            }
        }
    }

    preRequestPermissionLocation() {
        const that = this;
        const { t } = this.props;
        store.dispatch(setDialog({
            title: t('dialogs.locationRequest.title', 'Wil je jouw locatie automatisch invullen?'),
            message: t('dialogs.locationRequest.message', 'Als je toegang tot jouw locatie toestaat, kunnen we je adres automatisch invullen.'),
            btn1Text: t('dialogs.locationRequest.acceptButton', 'Vul locatie automatisch in'),
            btn1Title: "accept",
            btn1Theme: "primary",
            btn2Text: t('dialogs.locationRequest.denyButton', 'Liever niet'),
            btn2Title: "deny",
            response: that.handlePreRequestPermissionLocationResponse,
        }));
    }

    handlePreRequestPermissionLocationResponse(response) {
        store.dispatch(clearDialog());
        if (response === "accept") {
            this.requestLocation();
        } else if (response === "deny" || response === "dismiss") {
            // this.handleLocationDenied();
            store.dispatch(clearDialog());
            this.checkGeopositionAgainstStoredPosition(null, null);
        }
    }

    requestLocation() {
        const { t } = this.props;
        store.dispatch(setLoader({
            title: t('loaders.pleaseWait', 'Even geduld...'),
            message: t('loaders.determiningLocation', 'We bepalen je locatie'),
        }));

        const options = {
            enableHighAccuracy: true,
            timeout: 30000,
            maximumAge: 300000 // 5 minutes - use cached location if available
        };

        navigator.geolocation.getCurrentPosition(
            (geoposition) => {
                console.log('[CombinedButton] Location received:', geoposition.coords.latitude, geoposition.coords.longitude);
                this.handleLocationRecieved(geoposition);
            },
            (error) => {
                console.error('[CombinedButton] Location error:', error);
                this.handleLocationError(error);
            },
            options
        );
    }

    handleLocationRecieved(geoposition) {
        store.dispatch(clearLoader());
        localStorage.setItem('geolocation', "granted");
        this.checkGeopositionAgainstStoredPosition(geoposition.coords.latitude, geoposition.coords.longitude);
    }

    handleLocationError(error) {
        store.dispatch(clearLoader());
        console.log('[CombinedButton] Handling location error, code:', error.code);
        if (error.code === 1) {
            this.handleLocationDenied();
        } else {
            this.handleLocationFailed();
        }
    }

    handleLocationDenied() {
        localStorage.setItem('geolocation', "denied");
        const that = this;
        const { t } = this.props;
        store.dispatch(setDialog({
            title: t('dialogs.locationDenied.title', 'Je locatie kon niet worden bepaald'),
            message: t('dialogs.locationDenied.message', 'Je gaf geen toestemming om je adres automatisch te bepalen. Je zal je adres dus manueel moeten invullen.'),
            theme: "error",
            btn1Text: t('common.ok', 'Ok'),
            btn1Theme: "primary",
            response: () => {store.dispatch(clearDialog()); that.checkGeopositionAgainstStoredPosition(null, null)},
        }));
    }

    handleLocationFailed() {
        const that = this;
        const { t } = this.props;
        store.dispatch(setDialog({
            title: t('dialogs.locationFailed.title', 'Je locatie kon niet worden bepaald'),
            message: t('dialogs.locationFailed.message', 'Er ging iets mis tijdens het bepalen van je adres. Je zal je adres dus mogelijks manueel moeten invullen.'),
            btn1Text: t('common.ok', 'Ok'),
            btn1Theme: "primary",
            response: () => {store.dispatch(clearDialog()); that.checkGeopositionAgainstStoredPosition(null, null)},
        }));
    }

    checkGeopositionAgainstStoredPosition(lat, long) {
        if (!lat || !long) {
            //No GPS-latlong available
            const storedGpsLat = localStorage.getItem('gpslat') || null;
            const storedGpsLong = localStorage.getItem('gpslong') || null;
            if (!storedGpsLat || !storedGpsLong) {
                const storedLat = localStorage.getItem('latitude') || null;
                const storedLong = localStorage.getItem('longitude') || null;
                if (!storedLat || !storedLong) {
                    this.setState({
                        redirectToAddress: true,
                    });
                } else {
                    if (this.isStoredAddressValid()) {
                        this.checkKarrenInDeBuurt();
                    } else {
                        store.dispatch(setToast({
                            message: this.props.t('toasts.addressIncomplete', 'Je adres is niet volledig juist. Gelieve je adres aan te vullen'),
                            theme: "error"
                        }));
                        this.setState({
                            redirectToAddress: true,
                        });
                    }
                }
            } else {
                if (this.isStoredAddressValid()) {
                    this.checkKarrenInDeBuurt();
                } else {
                    store.dispatch(setToast({
                        message: this.props.t('toasts.addressIncomplete', 'Je adres is niet volledig juist. Gelieve je adres aan te vullen'),
                        theme: "error"
                    }));
                    this.setState({
                        redirectToAddress: true,
                    });
                }
            }
        } else {
            //GPS returned latlong
            const storedGpsLat = localStorage.getItem('gpslat') || null;
            const storedGpsLong = localStorage.getItem('gpslong') || null;
            if (!storedGpsLat || !storedGpsLong) {
                this.makeLocationTranslation(lat, long);
            } else {
                const dist = getDistanceFromLatLonInKm(lat, long, storedGpsLat, storedGpsLong);
                if (dist < 0.5) {
                    if (this.isStoredAddressValid()) {
                        this.checkKarrenInDeBuurt();
                    } else {
                        store.dispatch(setToast({
                            message: this.props.t('toasts.addressIncomplete', 'Je adres is niet volledig juist. Gelieve je adres aan te vullen'),
                            theme: "error"
                        }));
                        this.setState({
                            redirectToAddress: true,
                        });
                    }
                } else {
                    this.makeLocationTranslation(lat, long);
                }
            }
        }
    }

    isStoredAddressValid() {
        // Check that all required fields exist and are not empty
        // Note: localStorage.getItem returns null if key doesn't exist, so we need to check for both null and empty string
        const straat = localStorage.getItem('straat');
        const nr = localStorage.getItem('nr');
        const gemeente = localStorage.getItem('gemeente');
        const postcode = localStorage.getItem('postcode');
        const land = localStorage.getItem('land');
        const placeid = localStorage.getItem('placeid');

        return (straat && straat !== "" &&
                nr && nr !== "" &&
                gemeente && gemeente !== "" &&
                postcode && postcode !== "" &&
                land && land !== "" &&
                placeid && placeid !== "");
    }

    makeLocationTranslation(gpslat, gpslong) {
        const { t } = this.props;
        store.dispatch(setLoader({
            title: t('loaders.pleaseWait', 'Even geduld...'),
            message: t('loaders.fetchingLocation', 'We vragen je locatie op'),
        }));

        const formData = new FormData();
        formData.append('latitude', gpslat);
        formData.append('longitude', gpslong);

        fetch(process.env.REACT_APP_API_HREF+"legacycopy.php?action=get_adrestranslation",{
            method: 'POST', 
            body: formData,
        }).then(function(response) {
            return response.json();
        }).then(data => {
            console.log(data);
            if (data.status === 200) {
                store.dispatch(clearLoader());

                const result = data.result;
                this.setAdresStorage(gpslat, gpslong, result.adres, result.latitude, result.longitude, result.Straat, result.Nr, result.Gemeente, result.Postcode, result.Land, result.place_id);
                this.checkKarrenInDeBuurt();
            } else {
                this.handleLocationTranslationFailed();
            }
        }).catch(error => {
            console.log(error);
            this.handleLocationTranslationFailed();
        });
    }

    handleLocationTranslationFailed() {
        store.dispatch(clearLoader());

        const that = this;
        const { t } = this.props;
        store.dispatch(setDialog({
            title: t('dialogs.locationFailed.title', 'Je locatie kon niet worden bepaald'),
            message: t('dialogs.locationFailed.message', 'Er ging iets mis tijdens het bepalen van je adres. Je zal je adres dus mogelijks manueel moeten invullen.'),
            btn1Text: t('common.ok', 'Ok'),
            btn1Theme: "primary",
            response: () => {store.dispatch(clearDialog()); that.checkGeopositionAgainstStoredPosition(null, null)},
        }));
    }

    setAdresStorage(gpslat, gpslong, adres, latitude, longitude, straat, nr, gemeente, postcode, land, place_id) {
        window.localStorage.setItem('gpslat', gpslat);
        window.localStorage.setItem('gpslong', gpslong);
        window.localStorage.setItem('adres', adres);
        window.localStorage.setItem('latitude', latitude);
        window.localStorage.setItem('longitude', longitude);
        window.localStorage.setItem('straat', straat);
        window.localStorage.setItem('nr', nr);
        window.localStorage.setItem('gemeente', gemeente);
        window.localStorage.setItem('postcode', postcode);
        window.localStorage.setItem('land', land);
        window.localStorage.setItem('placeid', place_id);
    }

    checkKarrenInDeBuurt() {
        const { t } = this.props;
        store.dispatch(setLoader({
            title: t('loaders.pleaseWait', 'Even geduld...'),
            message: t('loaders.checkingNearby', 'We kijken of er IJskarren in jouw buurt zijn'),
        }));

        const latitude = localStorage.getItem('latitude') || 0;
        const longitude = localStorage.getItem('longitude') || 0;

        const url = process.env.REACT_APP_ICECORP_API_HREF+"v1/icecreamvanmarkerdata?company_id="+process.env.REACT_APP_COMPANY_ID;
        fetch(url)
        .then(response => response.json())
        .then(data => {
            const karren = data.data;
            let availableNearby = false;
            console.log(process.env.REACT_APP_DO_BLOCK_TOO_FAR_AWAY);
            let blockTooFarAway = ((process.env.REACT_APP_DO_BLOCK_TOO_FAR_AWAY === "1") ? true : false);
            console.log(blockTooFarAway);

            karren.forEach(kar => {
                const distanceFromLatLonInKm = getDistanceFromLatLonInKm(kar.latitude, kar.longitude, latitude, longitude);
                if (kar.available && distanceFromLatLonInKm <= (process.env.REACT_APP_THRESHOLD_FOR_BLOCK_TOO_FAR_AWAY/1000)) {
                    blockTooFarAway = false;
                }

                if (kar.available && distanceFromLatLonInKm <= (process.env.REACT_APP_THRESHOLD_FOR_CLOSE/1000)) {
                    availableNearby = true;
                }
            });

            store.dispatch(clearLoader());
            if (blockTooFarAway) {
                this.handleBlockTooFarAway();
            } else if (availableNearby) {
                this.handleAvailableNearby();
            } else {
                this.handleNoAvailableNearby();
            }
        })
        .catch(() => {
            const { t } = this.props;
            store.dispatch(clearLoader());
            store.dispatch(setDialog({
                title: t('dialogs.error.title', 'Fout!'),
                message: t('dialogs.error.checkNearbyFailed', 'We kunnen niet bepalen of er momenteel een IJskar in jouw buurt is! Probeer het later nog eens aub.'),
                theme: "error",
                btn1Text: t('common.ok', 'Ok'),
                btn1Theme: "primary",
                response: () => { store.dispatch(clearDialog()); },
            }));
        });
    }

    handleAvailableNearby() {
        store.dispatch(setAvailableNearby(true));
        const { t } = this.props;
        const address = (localStorage.getItem('adres') || "");
        const messageTemplate = t('dialogs.availableNearby.message', 'Er is een ijskar in de buurt van <br /><b>"{address}"</b><br /><br />Wil je hem laten weten dat jullie een ijsje willen?');
        store.dispatch(setDialog({
            title: t('dialogs.availableNearby.title', 'Hoera!'),
            message: messageTemplate.replace('{address}', address),
            btn1Text: t('dialogs.availableNearby.confirmButton', 'Oproep plaatsen!'),
            btn1Theme: "primary",
            btn1Title: "roep",
            btn2Text: t('dialogs.call.changeAddressButton', 'Adres wijzigen'),
            btn2Title: "adres",
            btn3Text: t('dialogs.call.cancelButton', 'Annuleer'),
            btn3Title: "annuleer",
            response: (response) => { this.handleAvailableResponse(response);},
        }));
    }

    handleNoAvailableNearby() {
        store.dispatch(setAvailableNearby(false));
        const { t } = this.props;
        const address = (localStorage.getItem('adres') || "");
        const messageTemplate = t('dialogs.noAvailableNearby.message', 'Er is geen beschikbare ijskar in de buurt van <br /><b>"{address}"</b><br /><br />Wil je toch een oproep plaatsen? Dan kan er misschien later op de dag nog een ijskar bij jullie langskomen.');
        store.dispatch(setDialog({
            title: t('dialogs.noAvailableNearby.title', 'Helaas!'),
            message: messageTemplate.replace('{address}', address),
            theme: "error",
            btn1Text: t('dialogs.noAvailableNearby.confirmButton', 'Toch een oproep plaatsen'),
            btn1Theme: "primary",
            btn1Title: "roep",
            btn2Text: t('dialogs.call.changeAddressButton', 'Adres wijzigen'),
            btn2Title: "adres",
            btn3Text: t('dialogs.call.cancelButton', 'Annuleer'),
            btn3Title: "annuleer",
            response: (response) => { this.handleAvailableResponse(response);},
        }));
    }

    handleBlockTooFarAway() {
        store.dispatch(setAvailableNearby(false));
        const { t } = this.props;
        const address = (localStorage.getItem('adres') || "");
        const messageTemplate = t('dialogs.tooFarAway.message', 'Er is geen beschikbare ijskar in de buurt van <br /><b>"{address}"</b>');
        store.dispatch(setDialog({
            title: t('dialogs.tooFarAway.title', 'Helaas!'),
            message: messageTemplate.replace('{address}', address),
            theme: "error",
            btn2Text: t('dialogs.call.changeAddressButton', 'Adres wijzigen'),
            btn2Title: "adres",
            btn3Text: t('dialogs.call.cancelButton', 'Annuleer'),
            btn3Title: "annuleer",
            response: (response) => { this.handleAvailableResponse(response);},
        }));
    }

    handleAvailableResponse(response) {
        if (response === "roep") {
            store.dispatch(clearDialog());
            store.dispatch(setLegitCall());
            this.setState({
                redirectToCall: true,
            });
        } else if (response === "adres") {
            store.dispatch(clearDialog());
            this.setState({
                redirectToAddress: true,
            });
        } else if (response === "annuleer") {
            store.dispatch(clearDialog()); 
        }
    }
    
    render() {
        if (this.state.redirectToCall === true) {
            return <Navigate to='/call' />
        }
        if (this.state.redirectToAddress === true) {
            return <Navigate to='/address' />
        }

        const label = this.state.oproepGeplaatst
            ? this.props.t('buttons.callPlaced', 'Oproep geplaatst')
            : this.props.t('buttons.callIceCream', 'Roep de ijskar!');

        // One red pill FAB, bottom-centre of the map (design briefing). Single
        // button element so handleClick fires exactly once per activation.
        return (
            <button
                type="button"
                className={`call-truck-fab ${this.state.oproepGeplaatst ? 'placed' : ''}`}
                onClick={(event) => {event.stopPropagation(); this.handleClick();}}
                onKeyDown={(event) => {
                    if (event.key === 'Enter' || event.key === ' ') {
                        event.preventDefault();
                        event.stopPropagation();
                        this.handleClick();
                    }
                }}
                aria-label={label}
                aria-pressed={this.state.oproepGeplaatst}
            >
                <WavingHand className='call-truck-fab-hand' />
                <span className="call-truck-fab-label">{label}</span>
            </button>
        )
    }
}

function mapStateToProps(state) {
    return {
        makeCallOnOpen: state.tracker.makeCallOnOpen ?? false,
    }
}

export default connect(mapStateToProps)(withTranslation(CombinedButton));